import { SchoolModel } from '@modules/school/school-model';

const { fields } = SchoolModel;

export default [
        fields.gender,
        fields.children,
        fields.country,
        fields.email,
        fields.role,
        fields.birthdate,
];